import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import { Stack } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers';

export default function DateCalendarDialog(props) {
    //   const [open, setOpen] = React.useState(false);
    const { open, setOpen, action, dt } = props;

    const [value, setValue] = React.useState(dayjs(dt?dt:new Date()));
    React.useEffect(()=>{
        if( open){
            setValue(dayjs(dt?dt:new Date()) )
        }
    },[open])

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        const email = formJson.email;
        console.log(email);
        handleClose();
    };

    function formataData(time) {
        if (!time) return '';
        const dt = new Date(time);
        return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
    }    

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>
                    {formataData(value)}
                </DialogTitle>
                <DialogContent sx={{ padding: 0 }}>
                    <Stack>
                        <DateCalendar 
                            value={value} onChange={(newValue) => setValue(newValue)} 
                        />
                        <TimePicker label="Horas" value={value}
                            onChange={(newValue) => setValue(newValue)}
                            ampm={false}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                    <Button onClick={()=>{
                        if( action )action(value);
                        handleClose();
                    }}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </LocalizationProvider>

    );
}
